module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DialogBox', {
    attrs: {
      "settings": _vm.settings,
      "disabled": !_vm.isFormValid
    },
    on: {
      "save": _vm.sendSMS,
      "show": _vm.showingDialog,
      "hide": _vm.hidingDialog
    }
  }, [_c('div', {
    staticClass: "pr-4 pl-4 pb-4",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-combobox', {
    attrs: {
      "single-line": "",
      "label": "Recipients",
      "chips": "",
      "multiple": "",
      "items": _vm.contactsWithMobiles,
      "return-object": "",
      "item-text": "fullName"
    },
    model: {
      value: (_vm.sms.recipients),
      callback: function($$v) {
        _vm.$set(_vm.sms, "recipients", $$v)
      },
      expression: "sms.recipients"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": 3,
      "label": _vm.prefix,
      "hint": _vm.suffix,
      "persistent-hint": ""
    },
    model: {
      value: (_vm.sms.message),
      callback: function($$v) {
        _vm.$set(_vm.sms, "message", $$v)
      },
      expression: "sms.message"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09c26d72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/SmsDialog.vue
// module id = 2442
// module chunks = 1